// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6CWUl","index":"styles_index__zVIe_"};